import React from "react";
import { withJsonFormsControlProps } from "@jsonforms/react";
import {
  and,
  hasOption,
  isMultiLineControl,
  rankWith,
  schemaTypeIs,
  uiTypeIs,
} from "@jsonforms/core";
import { Box, Typography } from "@mui/material";

/**
 * @typedef {Object} Props
 * @property {Object} schema - The JSON Schema for the control
 * @property {Object} uischema - The UI Schema for customizing the control
 * @property {*} data - The current value of the data bound to the control
 * @property {Function} handleChange - Callback to update the form data
 * @property {string} path - The data path for the control
 */

/**
 * TextAreaRenderer
 * A custom renderer for displaying and editing multi-line text.
 *
 * @param {Props} props - The properties passed to the renderer.
 * @returns {React.ReactElement} The rendered text area field.
 */
const textAreaRenderer = (props) => {
  if (!props.visible) {
    return null;
  }

  return (
    <Box>
      <Typography variant={"body1"} fontWeight={"bold"}>
        {props.label}:
      </Typography>
      <Typography variant={"body1"}>{props.data}</Typography>
    </Box>
  );
};

export const textAreaTester = rankWith(
  6,
  and(
    uiTypeIs("Control"),
    schemaTypeIs("string"),
    isMultiLineControl,
    hasOption("rows"),
  ),
);

export default withJsonFormsControlProps(textAreaRenderer);
